import { render, staticRenderFns } from "./WatchOnAir.vue?vue&type=template&id=5988f432&scoped=true"
import script from "./WatchOnAir.vue?vue&type=script&lang=ts"
export * from "./WatchOnAir.vue?vue&type=script&lang=ts"
import style0 from "./WatchOnAir.vue?vue&type=style&index=0&id=5988f432&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988f432",
  null
  
)

export default component.exports